import { SignOutAction } from "../auth/signOut/types";
import * as H from "history";
import { SignInAction } from "../auth/signIn/types";

export enum BREADCRUMBS_TYPES {
  COMPLETED = "BREADCRUMBS_COMPLETED",
  RESET = "BREADCRUMBS_RESET",
}

interface Completed {
  type: BREADCRUMBS_TYPES.COMPLETED;
  payload: H.Location;
}

interface Reset {
  type: BREADCRUMBS_TYPES.RESET;
}

export type BreadcrumbsAction = Completed | Reset | SignInAction | SignOutAction;
